import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
// @mui
import {
  Box,
  Grid,
  Card,
  Table,
  Divider,
  TableRow,
  Container,
  TableCell,
  Typography,
  TableContainer,
  LinearProgress,
} from '@mui/material';
import Image from '../../components/Image';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// utils
import { fCurrency } from '../../utils/formatNumber';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
// sections
import { InvoiceToolbar } from '../../sections/@dashboard/invioce/cable';
import axios from '../../utils/axios';
import useAuth from '../../hooks/useAuth';
import InvoiceWebLayout from '../../components/InvoiceWebLayout';
// ----------------------------------------------------------------------

export default function CableInvoice() {
  const { themeStretch } = useSettings();
  const { name = '' } = useParams();
  const [trans, Settrans] = useState('');
  const { setting } = useAuth();
  const [load, SetLoad] = useState(true);

  useEffect(() => {
    axios
      .get(`/api/cable/trans/${name}/secure`)
      .then((data) => {
        Settrans(data.data?.trans);
        SetLoad(false);
      })
      .catch(() => SetLoad(false));
  }, [name, Settrans]);

  return (
    <Page title="Cable Sub: Invoice">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="Cable Subscription Invoice"
          links={[{ name: 'Dashboard', href: PATH_DASHBOARD.root }, { name: 'cable sub - Invoice' }]}
        />

        {trans && <InvoiceToolbar invoice={trans} />}

        {trans &&
          (() => {
            let status = 'Processing';
            let statusColor = 'warning';
            if (trans.plan_status === 1) {
              status = 'Successful';
              statusColor = 'success';
            } else if (trans.plan_status === 2) {
              status = 'Failed';
              statusColor = 'error';
            }
            return (
              <InvoiceWebLayout
                logo="/upload/welcome.png"
                status={status}
                statusColor={statusColor}
                transactionId={trans.my_trans_id}
                details={[
                  { label: 'Cable Provider', value: trans.cable_name },
                  { label: 'Plan Name', value: trans.plan_name },
                  { label: 'IUC Number', value: trans.iuc },
                  { label: 'Customer Name', value: trans.customer_name },
                  { label: 'Amount', value: `₦${fCurrency(trans.amount)}`, highlight: true },
                  { label: 'Old Balance', value: `₦${fCurrency(trans.oldbal)}` },
                  { label: 'New Balance', value: `₦${fCurrency(trans.newbal)}` },
                  { label: 'Client Reference ID', value: trans.transid },
                  { label: 'System', value: trans.system },
                  { label: 'Date', value: trans.plan_date },
                ]}
                notes="We appreciate your continuous patronage. Your satisfaction is our top priority!"
                supportContact={setting?.general?.app_email}
              />
            );
          })()}

        {load && <LinearProgress sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: (theme) => theme.zIndex.drawer + 1 }} />}
      </Container>
    </Page>
  );
}
